import React from "react";
import { Container } from "react-bootstrap";

const ContactPage = () => {
  return (
    <Container>
    <div className="container mx-auto px-4 py-16 flex flex-col lg:flex-row gap-16" style={{padding:"40px"}}>
      {/* Left Section */}
      <div className="w-full lg:w-1/2 card-media__content">
      <div className=" card-media__content--left content-overlay content-overlay--bottom-left">
       
        <h2 className="text-3xl md:text-4xl font-bold mb-6">Just gives us a call!</h2>
        <p className="mb-4 text-gray-700">
          We strive to constantly improve the quality of our Products so that you can enjoy them as much as we enjoy making them. For us, the only thing that matters is your Satisfaction.
        </p>
        <p className="mb-4 text-gray-700">
          We also provide bulk orders for businesses. Just ring a bell or drop a message to get a hold of all the perks we offer with bulk orders.
        </p>
        <p className="mb-2 text-gray-700">
           Manufactured & Marketed By: PUSHPANJALI ECONIRMIT,    <br />
              12/16, Pragati Nagar, Nanakheda, <br />
              UJJAIN (M.P.)
        </p>
    
        <p className="mb-2 text-gray-700 underline">
          <a href="tel:+919266041944">+91 882737343s</a>
        </p>
        <p className="text-gray-700 underline">
          <a href="mailto:order@bonviesnacks.com">contact@econirmit.com</a>
        </p>
           
        </div>
      </div>

      {/* Right Section */}
      <div className="w-full lg:w-1/2 bg-[#f5f0ec] p-8 rounded-2xl contact__wrapper " style={{backgroundColor:"#F3EEEA"}}>
        <form>
          <div className="flex flex-col md:flex-row gap-4 mb-4">
            <div className="w-full">
              <label className="block text-sm font-medium mb-1">Name</label>
              <input
                type="text"
                placeholder="Name"
                className="w-full px-6 py-3 rounded-full outline-none"
              />
            </div>
            <div className="w-full">
              <label className="block text-sm font-medium mb-1">Email *</label>
              <input
                type="email"
                placeholder="Email"
                className="w-full px-6 py-3 rounded-full outline-none"
              />
            </div>
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Phone</label>
            <input
              type="text"
              placeholder="Phone"
              className="w-full px-6 py-3 rounded-full outline-none"
            />
          </div>
          <div className="mb-6">
            <label className="block text-sm font-medium mb-1">Your message</label>
            <textarea
              placeholder="Your message"
              rows={5}
              className="w-full px-6 py-3 rounded-xl outline-none resize-none"
            ></textarea>
          </div>
          <button
            type="submit"
            className="bg-black text-white px-10 py-3 rounded-full font-semibold transition hover:bg-gray-800"
          >
            Submit Now
          </button>
        </form>
      </div>
    </div>
    </Container>
  );
};

export default ContactPage;
